/* eslint-disable prefer-template */

const getLocationOrigin = () => {
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? ':' + port : ''}`;
};

/**
 * Gets parameters from URL, whether escaped or not
 * Test in Code Sandbox: https://codesandbox.io/s/geturlparams-htjco
 * Web example:
   https://dev.app.imaginarie.app/auth/action?apiKey=AIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI&mode=resetPassword&oobCode=xQWsCbkHmuB2HyxSKfF40EhAAXmLp_F8CqafGhjc6tMAAAFyUxSfpg&continueUrl=http://localhost:8080/auth&lang=en
 * Native deep-link example:
   https://dev.app.imaginarie.app/auth/action?apiKey%3DAIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI%26mode%3DresetPassword%26oobCode%3D8y50MSSILYahwzn4tb6ff76mKz7iNsSd03YJSgPe7ucAAAFyVCRkYA%26continueUrl%3Dhttps://dev.app.imaginarie.app%26lang%3Den
   &apn=app.imaginarie.app.dev&amv=23&ibi=app.imaginarie.app.dev&ifl=https://dev.app.imaginarie.app/auth/action?apiKey%3DAIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI%26mode%3DresetPassword%26oobCode%3D8y50MSSILYahwzn4tb6ff76mKz7iNsSd03YJSgPe7ucAAAFyVCRkYA%26continueUrl%3Dhttps://dev.app.imaginarie.app%26lang%3Den
 * Link from Android
   https://app.imaginarie.app/auth/action?mode=verifyEmail&oobCode=8qeXjvhMko6ezMnnreHCbBHx4Rd15NcT0NFE4k3o-owAAAF1-IY3Zw&apiKey=AIzaSyCwze-J7xSAKV2xJaKpmLHFG4TmvsBwYdI&continueUrl=https%3A%2F%2Flink.imaginarie.app%3Flink%3Dhttps%3A%2F%2Fapp.imaginarie.app%26apn%3Dapp.imaginarie.app%26amv%3D23%26ibi%3Dapp.imaginarie.app%26ifl%3Dhttps%3A%2F%2Fapp.imaginarie.app&lang=en&utm_source=sendinblue&utm_campaign=Verify_Email&utm_medium=email  
 * With dynamic link
   https://dev.link.imaginarie.app/?link=https://dev.app.imaginarie.app/auth/action?apiKey%3DAIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI%26mode%3DresetPassword%26oobCode%3DmiaH_nMX6CDgGpJZzt4cys3NRtHC5qDHJR846-aNJR0AAAF3dbZiaA%26continueUrl%3Dhttps://dev.app.imaginarie.app%26lang%3Den&apn=app.imaginarie.app.dev&amv=23&ibi=app.imaginarie.app.dev&ifl=https://dev.app.imaginarie.app/auth/action?apiKey%3DAIzaSyC1tjBDvojenc8e6HByWRv7YUjOs3_V_ZI%26mode%3DresetPassword%26oobCode%3DmiaH_nMX6CDgGpJZzt4cys3NRtHC5qDHJR846-aNJR0AAAF3dbZiaA%26continueUrl%3Dhttps://dev.app.imaginarie.app%26lang%3Den?utm_source=sendinblue&utm_campaign=Reset_Password&utm_medium=email
   * @param {String} url 
 * @returns {Object} Object of url params
 */
const getUrlParams = url => {
  let unescapedUrl = url.replace(/%26/g, '&');
  unescapedUrl = unescapedUrl.replace(/%3D/g, '=');
  const paramArray = unescapedUrl.split('action?')[1].split('&');

  const params = {};
  paramArray.forEach(param => {
    const [key, value] = param.split('=');
    params[key] = value;
  });
  return params;
};

export { getLocationOrigin, getUrlParams };
